'use client';

import { useRef, useState } from 'react';
import { useTranslations } from 'next-intl';

import DesktopFilters from './desktop-filter';
import MobileFilters from './mobile-filter';

const Filters = ({ filters, catId, isMobile }) => {
  const t = useTranslations('common');
  const catMenuRef = useRef();
  const [modalType, setModalType] = useState(null);

  const buttonStyles = 'bg-primary text-white';

  return (
    <>
      {!isMobile ? (
        <DesktopFilters filters={filters} t={t} catId={catId} />
      ) : (
        <MobileFilters
          ref={catMenuRef}
          t={t}
          buttonStyles={buttonStyles}
          setModalType={setModalType}
          modalType={modalType}
          filters={filters}
        />
      )}
    </>
  );
};

export default Filters;
